import { render, staticRenderFns } from "./particulars.vue?vue&type=template&id=3c41f85e&scoped=true&"
import script from "./particulars.vue?vue&type=script&lang=js&"
export * from "./particulars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c41f85e",
  null
  
)

export default component.exports